import { render, staticRenderFns } from "./FormDescuento.vue?vue&type=template&id=097402b2"
import script from "./FormDescuento.vue?vue&type=script&lang=js"
export * from "./FormDescuento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports